<div class="sub-menu-root-container report-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('weekly-result-by-store')" class="mat-list-item"
            routerLink="/report/weekly-result-by-store" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Weekly Result By Store' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reports.svg">
                <span class="master-title"> Weekly Result By Store


                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('ytd-result-by-store')" class="mat-list-item"
            routerLink="/report/ytd-result-by-store" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'YTD Result By Store' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reports.svg">
                <span class="master-title">YTD Result By Store


                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('weekly-result-by-branch')"
            class="mat-list-item" routerLink="/report/weekly-result-by-branch" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Weekly Result By Branch' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reports.svg">
                <span class="master-title">Weekly Result By Branch

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('ytd-result-by-branch')" class="mat-list-item"
            routerLink="/report/ytd-result-by-branch" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'YTD Result By Branch' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reports.svg">
                <span class="master-title">YTD Result By Branch

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('expense-type-summary')" class="mat-list-item"
            routerLink="/report/expense-type-summary" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Expense Type Summary' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/expense-type-summary-report.svg">
                <span class="master-title">Expense Type Summary

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('cash-variance-exception')"
            class="mat-list-item" routerLink="/report/cash-variance-exception" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Cash Variance Exception' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/cash-variance-exception-report.svg">
                <span class="master-title">Cash Variance Exception

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('attendance-exception')" class="mat-list-item"
            routerLink="/report/attendance-exception" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Attendance Exception' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/attendance-exception-report.svg">
                <span class="master-title">Attendance Exception

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('daily_sales')" class="mat-list-item"
            routerLink="/report/daily-sales-summary" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Sales Summary(Daily)' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/daily-sales-report.svg">
                <span class="master-title">Sales Summary(Daily)

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('weekly_sales')" class="mat-list-item"
            routerLink="/report/weekly-sales-summary" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Sales Summary(Weekly)' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/weekly-sales-report.svg">
                <span class="master-title">Sales Summary(Weekly)

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('yearly-result-by-week-hq')"
            class="mat-list-item" routerLink="/report/yearly-result-by-week-hq" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Yearly Result By Week' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/daily-sales-report.svg">
                <span class="master-title">Yearly Result By Week

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('master-sales-report')" class="mat-list-item"
            routerLink="/report/master-sales-report" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Master Sales Report' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/master-sales-report.svg">
                <span class="master-title">Master Sales Report

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('orders')" class="mat-list-item"
            routerLink="/report/orders" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Orders' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reports.svg">
                <span class="master-title">Orders

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('weekly-report')" class="mat-list-item"
            routerLink="/report/weekly-report" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Weekly Sales' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reports.svg">
                <span class="master-title">Weekly Sales

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('weekly-cash-and-banking-report')"
            class="mat-list-item" routerLink="/report/weekly-cash-and-banking-report" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Weekly Cash & Banking' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/weekly-cash-and-banking.svg">
                <span class="master-title">Weekly Cash & Banking

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('expense-details-report')"
            class="mat-list-item" routerLink="/report/expense-details-report" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Expense Details' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/expense-details-report.svg">
                <span class="master-title">Expense Details

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('hourly-sales-report')" class="mat-list-item"
            routerLink="/report/hourly-sales-report" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Hourly Sales' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/hourly-sales-report.svg">
                <span class="master-title">Hourly Sales

                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('daily-sales')" class="mat-list-item"
            routerLink="/report/daily-sales" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Sales Summary(Daily)' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/daily-sales-report.svg">
                <span class="master-title">Sales Summary(Daily)

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="(userData?.user_type === 'SHOP' || userData?.user_type === 'HQ') && hasAccess('daily-sales-report')" class="mat-list-item"
            routerLink="/report/daily-sales-report" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Daily Sales' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/daily-sales-report.svg">
                <span class="master-title">Daily Sales

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('day-end-report')" class="mat-list-item"
            routerLink="/report/day-end-report" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Day End' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/day-end-report.svg">
                <span class="master-title">Day End

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('weekly-sales')" class="mat-list-item"
            routerLink="/report/weekly-sales" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Sales Summary(Weekly)' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/weekly-sales-report.svg">
                <span class="master-title">Sales Summary(Weekly)

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('access-log')" class="mat-list-item"
            routerLink="/report/access-log" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Access Log' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="/assets/images/menu/svg/access-log.svg">
                <span class="master-title">Access Log

                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('master-sales-report-cost')"
            class="mat-list-item" routerLink="/report/master-sales-report-cost" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Master Sales' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/master-sales-report.svg">
                <span class="master-title">
                    Master Sales
                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('sales-report-by-groups')"
            class="mat-list-item" routerLink="/report/sales-report-by-groups" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Sales Report By Groups' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/sale-report-by-group.svg">
                <span class="master-title">
                    Sales Report By Groups
                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('yearly-result-by-week-shop')"
            class="mat-list-item" routerLink="/report/yearly-result-by-week-shop" [routerLinkActive]="['is-active']"
            (click)="resetState()" [matTooltip]="!show ? 'Yearly Result By Week' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/yearly-result-by-week.svg">
                <span class="master-title">
                    Yearly Result By Week

                </span>
            </div>
        </mat-list-item>




    </div>
</div>